import React, {useContext, useEffect} from "react";
import {observer} from "mobx-react";
import NavBarTemplate from "./NavBarTemplate";
import {model} from "./models/Model";
import RouteOption from "./Components/RouteOption";
import {AuthContext} from "../../../context/AuthContext";
import NavbarStore from "./store/NavbarStore";
import './sass/NavBar.sass'
import DropdownRouteOption from "./Components/DropdownRouteOption";

const NavBar = observer(() => {
        const {roleId} = useContext(AuthContext)
        window.addEventListener('resize',
            () => {
                NavbarStore.setMobile(window.innerWidth)
            })

        const handler = () => {
            NavbarStore.setCurrentPage(window.location.pathname)
        }

        function routesListCreator(roleId, onCLick) {
            const navBar = []
            model.forEach(
                role => {
                    if (roleId === role.id) {
                        role.links.forEach(route => {
                            route.dropDownRouteList
                                ? navBar.push(
                                <DropdownRouteOption
                                    onClick={e => {onCLick(e)}}
                                    routeOrigin={route.routeOrigin}
                                    key={route.title + route.route}
                                    title={route.title}
                                    link={route.route}
                                    routeList={route.dropDownRouteList}
                                />
                                )
                                : navBar.push(
                                <RouteOption
                                    routeOrigin={route.routeOrigin}
                                    key={route.title + route.route}
                                    title={route.title}
                                    link={route.route}
                                    onClick={e => {
                                        onCLick(e)
                                    }}
                                />)
                        })
                    }
                }
            )
            return navBar

        }

        useEffect(() => {
            NavbarStore.setCurrentPage(window.location.href)
            NavbarStore.setMobile(window.innerWidth)

        })

        return (
            <NavBarTemplate
                routeList={routesListCreator(roleId, handler)}
                onClick={
                    e => {
                        handler(e)
                    }}/>)

    }
)


export default NavBar


//
// //patient
// if (value === 7) {
//     return (
//         <div className="top-bar mobile">
//             <div className={'routing'}>
//
//                 <div className={'top-bar__option'}>
//                     <div className="top-bar__option__line">
//                         <div className="line"/>
//                     </div>
//                     <Link to="/patient-payments"> Личный кабинет</Link>
//                 </div>
//
//                 <div className={'top-bar__option_active'}>
//                     <div className="top-bar__option__line">
//                         <div className="line"/>
//                     </div>
//                     <Link className='link' to="/patient-payments"> История платежей</Link>
//                 </div>
//
//             </div>
//         </div>
//     )
// }
// //doctor
// else if (value === 6) {
//     return (
//         <div className="top-bar">
//             <a href="/PatientPage">Личный кабинет</a>
//             <a href="/#">Тестирование</a>
//             <a href="/#">Чтение снимков</a>
//             <a href="/#">Статистика</a>
//             <a href="/#">Кошелек</a>
//         </div>
//     )
// }
// //Удостоверяющий центр
// else if (value === 5) {
//     return (
//         <div className="top-bar">
//             <a href="/PatientPage">Пациенты</a>
//             <a href="/#">Обследования</a>
//             <a href="/#">Контрагенты</a>
//             <a href="/#">Календарь</a>
//             <a href="/#">История выездов</a>
//             <a href="/#">Доктора</a>
//             <a href="/#">Активность</a>
//             <a href="/#">Точка</a>
//             <a href="/#">Доктор</a>
//             <a href="/#">Документы</a>
//         </div>
//     )
// }
// //Мед организация
// else if (value === 4) {
//     return (
//         <div className="top-bar">
//             <a href="/PatientPage">Личный кабинет</a>
//             <a href="/#">Организации</a>
//         </div>
//     )
// }
// //Организации
// else if (value === 3) {
//     return (
//         <div className="top-bar">
//             <a href="/PatientPage">Личный кабинет</a>
//         </div>
//     )
// }
// //Менеджер системы
// else if (value === 2) {
//     return (
//         <div className="top-bar">
//             <a href="/PatientPage">Главная</a>
//             <a href="/PatientPage">Доктор</a>
//             <a href="/PatientPage">Список врачей</a>
//             <a href="/PatientPage">Тестирование</a>
//             <a href="/PatientPage">Контроль качества</a>
//             <a href="/PatientPage">Контрагенты</a>
//             <a href="/PatientPage">Удостоверяющие центры</a>
//             <a href="/PatientPage">Медецинские центры</a>
//             <a href="/PatientPage">Организации</a>
//             <a href="/PatientPage">Все</a>
//             <a href="/PatientPage">Календарь</a>
//             <a href="/PatientPage">История выездов</a>
//             <a href="/PatientPage">Активность</a>
//             <a href="/PatientPage">Платформы</a>
//             <a href="/PatientPage">Точек</a>
//             <a href="/PatientPage">Докторов</a>
//             <a href="/PatientPage">Пациенты</a>
//         </div>
//     )
// }
// //Удостоверяющий центр лаборант
// else {
//     return (
//         <div className="top-bar">
//             <a href="/PatientPage">Пациенты</a>
//             <a href="/PatientPage">Обследования</a>
//             <a href="/PatientPage">Контрагенты</a>
//             <a href="/PatientPage">Календарь</a>
//             <a href="/PatientPage">История выездов</a>
//         </div>
//     )
// }